import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { bootstrapDateFormat } from "./format";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // Bootstrap the global date-format from platform settings on every mount.
    bootstrapDateFormat(api);
    const token = localStorage.getItem("mf_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      // Fetch staff context (roles across all facilities) so the frontend can
      // render the right sidebar + gate role-specific UI.
      try {
        const ctx = await api.get("/me/staff-context");
        setUser({ ...data, staff_roles: ctx.data.roles || [] });
      } catch {
        setUser(data);
      }
    } catch {
      localStorage.removeItem("mf_token");
      setUser(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mf_token", data.token);
    // Fetch full context (including staff_roles) so RBAC gating and sidebar
    // render correctly on the very first render after login.
    try {
      const ctx = await api.get("/me/staff-context");
      setUser({ ...data.user, staff_roles: ctx.data.roles || [] });
    } catch {
      setUser(data.user);
    }
    return data.user;
  };

  const register = async (payload) => {
    // payload = { email, password, name, mobile?, qualification?, bio?, workplace?,
    //             state_medical_council?, registration_number?, preferred_callback_time? }
    const { data } = await api.post("/auth/register", payload);
    if (data?.token) {
      localStorage.setItem("mf_token", data.token);
      setUser(data.user);
    }
    return data;
  };

  const logout = () => {
    localStorage.removeItem("mf_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
